import { atom } from "jotai";
import { atomFamily, loadable } from "jotai/utils";

import { $remoteWorkspace } from "../../internal/document/sharing/permissions.atom";

export const $remoteWorkspaceName = atomFamily((documentId: string | undefined) => {
	const nameAtom = atom(async (get) => {
		return (await get($remoteWorkspace(documentId)))?.name;
	});
	nameAtom.debugLabel = `remoteWorkspaceName/${documentId}`;
	return nameAtom;
});

export const $remoteWorkspaceId = atomFamily((documentId: string | undefined) => {
	const idAtom = atom(async (get) => {
		return (await get($remoteWorkspace(documentId)))?.id;
	});
	idAtom.debugLabel = `remoteWorkspaceId/${documentId}`;
	return idAtom;
});

export const $remoteWorkspaceSlug = atomFamily((documentId: string | undefined) => {
	const slugAtom = atom(async (get) => {
		return (await get($remoteWorkspace(documentId)))?.slug;
	});
	slugAtom.debugLabel = `remoteWorkspaceSlug/${documentId}`;
	return slugAtom;
});

export const $loadableRemoteWorkspaceId = atomFamily((documentId: string | undefined) =>
	loadable($remoteWorkspaceId(documentId))
);

export const $loadableRemoteWorkspaceSlug = atomFamily((documentId: string | undefined) =>
	loadable($remoteWorkspaceSlug(documentId))
);

export const $remoteRepoExists = atomFamily((documentId: string | undefined) => {
	const existsAtom = atom(async (get) => {
		const workspace = await get($remoteWorkspace(documentId));
		if (!workspace) {
			return false;
		}

		return true;
	});
	existsAtom.debugLabel = `remoteRepoExists/${documentId}`;
	return existsAtom;
});
